import initCardsSection from "../Components/Sections/AdvantageCardsSection";
import "Styles/Pages/ManagedOfficeLP.scss";

initCardsSection();